import Codebox from '../components/Codebox'

const NewCodebox: React.FC = () => {
    return (
        <Codebox />
    )
}

export default NewCodebox;